import styled from 'styled-components';
import PlusIcon from './PlusIcon';

const RemoveIcon = styled(PlusIcon)`
  --cross-color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.danger};
  transform: rotateZ(45deg);
`;

export default RemoveIcon;